import { useMemo, useCallback } from "react";
import { useDispatch } from "react-redux";
import { setSearch } from "../../Store/SearchReducer/action";

export const useLeadStatusSearch = ({
  leadStatusData,
  leadsearch,
  enqueueSnackbar,
  internationalise,
  handleValidateCodevalue,
  statusCode,
  searchEntity,
  handleSearchLeadPaged
}) => {
  const dispatch = useDispatch();

  const statusObjects = useMemo(() => {
    if (!Array.isArray(leadStatusData)) return [];

    return leadStatusData.filter(
      ({ systemLookupCode }) => systemLookupCode?.name === statusCode
    );
  }, [leadStatusData, statusCode]);

  const handleStatusSearch = useCallback(() => {
    if (!leadsearch?.selectedOwner) {
      enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_SELECT_OWNER_WARNING"),{ variant: "warning" });
      return;
    }

    if (statusObjects.length === 0) return;

    const updatedSearch = {
      ...leadsearch,
      status: statusObjects
    };

    dispatch(setSearch(searchEntity, updatedSearch));
    handleSearchLeadPaged(0, updatedSearch);
  }, [
    leadsearch, statusObjects, enqueueSnackbar, internationalise,
    handleValidateCodevalue, dispatch, searchEntity, handleSearchLeadPaged
  ]);

  return { statusObjects, handleStatusSearch };
};
